module.exports = __webpack_public_path__ + "img/base_activites_bien_etre.27d2f343.svg";